export var ADMIN_ROUTE = "/manage";
export var MIGRATE_ROUTE = ADMIN_ROUTE + "/migrate";
